// Resolved URL for the Rive school-background animation. Kept in its own module
// (with NO Rive imports) so the URL can be referenced — and the asset
// preloaded — in parallel with the lazily loaded SchoolBackground chunk,
// without pulling the heavy @rive-app Rive runtime into the eager graph.
// Consumed by SchoolBackground (the actual <Rive> src) and by the preloader in
// PrimaryRegistrationV2.
const RIVE_FILE_NAME = "parent_onboarding_v2.riv";

const getCdnBase = () =>
	`https://${global.ESSENTIAL_RESOURCES_DISTRIBUTION_DOMAIN_NAME}`;

const getRiveAnimationFile = (fileName: string) =>
	getCdnBase() + "/onboarding/animations/" + fileName;

// const getLocalRiveAnimationFile = function(fileName: string) {
// 	return global.BASE_URL + "assets/animations/rive/" + fileName;
// };

export const SCHOOL_BACKGROUND_RIVE_URL = getRiveAnimationFile(RIVE_FILE_NAME);

export const SCHOOL_BACKGROUND_IMAGE_URL =
	getCdnBase() + "/onboarding/images/onboardingPreloadScreen.png";

export const MOBILE_SCHOOL_BACKGROUND_IMAGE_URL =
	getCdnBase() + "/onboarding/images/onboardingLowBandwidthStart.svg";

export const SCHOOL_BACKGROUND_WASM_URL =
	getCdnBase() + "/onboarding/rive/rive.wasm";

let preloaded = false;

// Kicks off the network fetch for the .riv asset and the placeholder image in
// parallel with the lazily loaded SchoolBackground JS chunk. The browser
// dedupes the .riv link against Rive's own fetch when attributes match.
// Idempotent.
export const preloadSchoolBackgroundAsset = ({
	skipRiv = false,
}: {skipRiv?: boolean} = {}) => {
	if (preloaded || typeof document === "undefined") return;
	preloaded = true;

	if (!skipRiv) {
		const riv = document.createElement("link");
		riv.rel = "preload";
		riv.as = "fetch";
		riv.href = SCHOOL_BACKGROUND_RIVE_URL;
		riv.crossOrigin = "anonymous";
		document.head.appendChild(riv);

		const wasm = document.createElement("link");
		wasm.rel = "preload";
		wasm.as = "fetch";
		wasm.href = SCHOOL_BACKGROUND_WASM_URL;
		wasm.crossOrigin = "anonymous";
		document.head.appendChild(wasm);
	}

	const img = document.createElement("link");
	img.rel = "preload";
	img.as = "image";
	img.href = skipRiv
		? MOBILE_SCHOOL_BACKGROUND_IMAGE_URL
		: SCHOOL_BACKGROUND_IMAGE_URL;
	document.head.appendChild(img);
};
